// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import useProductFilteredVariantTraits from "@store/Framework/Common/Hooks/useProductFilteredVariantTraits";
import ProductVariantTraitValues, {
    ProductVariantTraitValuesPresentationProps,
} from "@store/Library/Components/ProductVariantTraitValues";
import React, { FC } from "react";

export interface ProductLineVariantTraitValuesPresentationProps extends ProductVariantTraitValuesPresentationProps {}

export interface ProductLineVariantTraitValuesProps extends ProductLineVariantTraitValuesPresentationProps {
    productId?: string | null | undefined;
    productUri?: string | null | undefined;
}

const ProductLineVariantTraitValues: FC<ProductLineVariantTraitValuesProps> = ({
    productId,
    productUri,
    ...productVariantTraitValuesProps
}) => {
    const product = useAppSelector(state => {
        if (productId) {
            return getProductState(state, productId)?.value;
        }

        if (productUri) {
            return getProductStateByPath(state, productUri)?.value;
        }

        return undefined;
    });

    const filteredVariantTraits = useProductFilteredVariantTraits(product);

    if (!product || !filteredVariantTraits.length) {
        return null;
    }

    return <ProductVariantTraitValues {...productVariantTraitValuesProps} product={product} />;
};

export default ProductLineVariantTraitValues;
